export default __webpack_public_path__ + "static/media/tipovaya-forma-celevogo-obecheniya.06dce364.pdf";